export abstract class LoggerService {
    abstract log(obj: any): void;
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/logger.ts